<app-main-layout>
  <section class="notifications-page" aria-labelledby="notifications-title">
    <header class="page-heading">
      <div>
        <h1 id="notifications-title">Оповещения</h1>
        <p>История действий по клиентам, событиям, заказам, рассылкам и системным изменениям.</p>
      </div>

      <button class="read-all-button" type="button" (click)="markAllAsRead()" [disabled]="unreadCount === 0">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m20 6-11 11-5-5"/><path d="m15 6-7 7-3-3"/></svg>
        <span>Все прочитано</span>
      </button>
    </header>

    <section class="notifications-panel">
      <header class="panel-heading">
        <div class="panel-title">
          <h2>Все оповещения</h2>
          <span *ngIf="unreadCount > 0">{{ unreadCount }} непрочитано</span>
        </div>

        <div class="filter-tabs" role="tablist" aria-label="Фильтр оповещений">
          <button type="button" role="tab" [class.active]="activeFilter === 'all'" (click)="setFilter('all')">Все</button>
          <button type="button" role="tab" [class.active]="activeFilter === 'unread'" (click)="setFilter('unread')">Новые</button>
          <button type="button" role="tab" [class.active]="activeFilter === 'read'" (click)="setFilter('read')">Прочитанные</button>
        </div>
      </header>

      <div class="summary-row">
        <article>
          <span>Всего</span>
          <strong>{{ notifications.length }}</strong>
        </article>
        <article>
          <span>Новые</span>
          <strong>{{ unreadCount }}</strong>
        </article>
        <article>
          <span>Прочитанные</span>
          <strong>{{ readCount }}</strong>
        </article>
      </div>

      <div class="notifications-list" *ngIf="filteredNotifications.length > 0; else emptyNotifications">
        <article
          class="notification-row"
          *ngFor="let notification of filteredNotifications; trackBy: trackByNotificationId"
          [ngClass]="['tone-' + notification.kind, notification.read ? '' : 'unread']"
          (click)="markAsRead(notification)"
        >
          <div class="notification-icon">
            <svg *ngIf="notification.kind === 'order'" viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2 2h3l3 12h10l3-8H6"/></svg>
            <svg *ngIf="notification.kind === 'client'" viewBox="0 0 24 24" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-8 0v2"/><circle cx="12" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/></svg>
            <svg *ngIf="notification.kind === 'event'" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 2v4"/><path d="M16 2v4"/><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M3 10h18"/></svg>
            <svg *ngIf="notification.kind === 'mailing'" viewBox="0 0 24 24" aria-hidden="true"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>
            <svg *ngIf="notification.kind === 'telegram'" viewBox="0 0 24 24" aria-hidden="true"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>
            <svg *ngIf="notification.kind === 'finance'" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M7 10h.01"/><path d="M17 14h.01"/></svg>
            <svg *ngIf="notification.kind === 'calendar'" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 2v4"/><path d="M16 2v4"/><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M8 14h.01"/><path d="M12 14h.01"/><path d="M16 14h.01"/></svg>
            <svg *ngIf="notification.kind === 'kanban'" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="18" rx="2"/><rect x="14" y="3" width="7" height="10" rx="2"/></svg>
            <svg *ngIf="notification.kind === 'directory'" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16v16H4z"/><path d="M9 4v16"/><path d="M4 9h5"/></svg>
            <svg *ngIf="notification.kind === 'user'" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 21a8 8 0 1 0-16 0"/><circle cx="12" cy="7" r="4"/></svg>
            <svg *ngIf="notification.kind === 'system'" viewBox="0 0 24 24" aria-hidden="true"><path d="M12.22 2h-.44a2 2 0 0 0-2 2l-.11.67a2 2 0 0 1-2.95 1.21l-.56-.36a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.56.36a2 2 0 0 1 0 3.46l-.56.36a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.56-.36a2 2 0 0 1 2.95 1.21l.11.67a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2l.11-.67a2 2 0 0 1 2.95-1.21l.56.36a2 2 0 0 0 2.73-.73l.22-.38a2 2 0 0 0-.73-2.73l-.56-.36a2 2 0 0 1 0-3.46l.56-.36a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.56.36a2 2 0 0 1-2.95-1.21L14.22 4a2 2 0 0 0-2-2Z"/></svg>
          </div>

          <div class="notification-copy">
            <div>
              <strong>{{ notification.title }}</strong>
              <span class="unread-dot" *ngIf="!notification.read" aria-hidden="true"></span>
            </div>
            <p>{{ notification.actor }} - {{ notification.description }}</p>
            <small>{{ getKindLabel(notification.kind) }}</small>
          </div>

          <time>{{ formatRelativeTime(notification.createdAt) }}</time>
        </article>
      </div>

      <ng-template #emptyNotifications>
        <div class="empty-state">
          <strong>Оповещений пока нет</strong>
          <span>Когда появятся действия в клиентах, событиях, заказах или рассылках, они появятся здесь.</span>
        </div>
      </ng-template>
    </section>
  </section>
</app-main-layout>
